import VueCqrs from '@cqrs/vue-component-cqrs';
import { RawCriterionWeight } from '@Criteria/Model';
import * as c from '@Criteria/Weights/Domain/commands-core';
import Component from 'vue-class-component';

@Component
export default class CriteriaWeightsCommands extends VueCqrs 
{
	invokeDeleteWeightsSetCommandV1(workspaceId: number, chId: number, cwsId: number)
	{
		const cmd = new c.DeleteWeightsSetCommandV1(workspaceId, chId, cwsId);
		this.$command(cmd, cwsId.toString());
	}

	invokeCreateWeightsSetCommandV1(workspaceId: number, chId: number, name: string, weights: RawCriterionWeight[])
	{
		const cmd = new c.CreateWeightsSetCommandV1(workspaceId, chId, name, weights);
		this.$command(cmd);
	}

	invokeUpdateWeightsSetCommandV1(workspaceId: number, chId: number, weightsSetId: number, name: string, weights: RawCriterionWeight[])
	{
		const cmd = new c.UpdateWeightsSetCommandV1(workspaceId, chId, weightsSetId, name, weights);
		this.$command(cmd, weightsSetId.toString());
	}



	invokeExportAllWeightsToXlsCommandV1(workspaceId: number, projectId: number, chId: number, evalModelId: number)
	{
		const cmd = new c.ExportAllWeightsToXlsCommandV1(workspaceId, projectId, chId, evalModelId);
		this.$command(cmd);
	}

	invokeExportWeightsToXlsFromPanelistVotesCommandV1(workspaceId: number, projectId: number, chId: number, evalModelId: number, projectUserId: number)
	{
		const cmd = new c.ExportWeightsToXlsFromPanelistVotesCommandV1(workspaceId, projectId, chId, evalModelId, projectUserId);
		this.$command(cmd);
	}

	invokeExportWeightsToXlsFromSurveyVotesCommandV1(workspaceId: number, projectId: number, chId: number, evalModelId: number, surveyId: number)
	{
		const cmd = new c.ExportWeightsToXlsFromSurveyVotesCommandV1(workspaceId, projectId, chId, evalModelId, surveyId);
		this.$command(cmd);
	}

	invokeExportWeightsToXlsFromWeightsSetCommandV1(workspaceId: number, projectId: number, chId: number, weightsSetId: number)
	{
		const cmd = new c.ExportWeightsToXlsFromWeightsSetCommandV1(workspaceId, projectId, chId, weightsSetId);
		this.$command(cmd);
	}
}
